module.exports = __webpack_public_path__ + "static/media/MATH-BUSD.cb25f295.svg";